package app.bloomey.web.core.res

import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import org.jetbrains.compose.web.css.px

val Res.Dimens.dashboardGutterWidth: CSSLengthOrPercentageNumericValue
    get() = 60.px